var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderContent',{attrs:{"header":"ตั้งค่าเว็บไซต์","img_header":_vm.header_image,"link_back":"content"}}),_c('MenuContentSetting'),_c('ContentContactList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }